"use client";

import { motion } from "framer-motion";
import categories from "@/data/categories.json";
import {
  Piano,
  Guitar,
  Music,
  Drum,
  Headphones,
  Cpu,
  Package,
  Music2,
} from "lucide-react";

interface CategoryCardsProps {
  onSelect: (cat: any) => void;
  selectedCategory?: any;
}

export default function CategoryCards({
  onSelect,
  selectedCategory,
}: CategoryCardsProps) {
  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          카테고리를 선택해주세요
        </h2>
        <p className="text-gray-600">어떤 종류의 악기를 등록하시나요?</p>
      </div>

      <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
        {categories.categories.map((cat, index) => {
          const isSelected = selectedCategory?.id === cat.id;
          const IconComponent = getCategoryIcon(cat.id);
          return (
            <motion.button
              key={cat.id}
              type="button"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              className={`p-4 border-2 rounded-[14px] transition-all duration-200 ${
                isSelected
                  ? "border-[#7A56E8] bg-gradient-to-br from-[#7A56E8] to-[#9B82FF] text-white shadow-[0_4px_12px_rgba(122,86,232,0.25)]"
                  : "border-gray-200 bg-white text-gray-700 hover:border-[#7A56E8]/30 hover:shadow-[0_2px_8px_rgba(0,0,0,0.12)]"
              }`}
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                console.log("CategoryCards: 카테고리 선택됨", cat);
                onSelect(cat);
              }}
              aria-label={`${cat.name} 카테고리 선택`}
              role="button"
            >
              <div className="flex items-center justify-center h-full min-h-[48px]">
                <div className={`font-semibold text-xs sm:text-base leading-tight text-center whitespace-nowrap break-keep ${
                  isSelected ? "text-white" : "text-gray-700"
                }`}>
                  {cat.name}
                </div>
              </div>
            </motion.button>
          );
        })}
      </div>
    </div>
  );
}

// 카테고리별 아이콘 컴포넌트 매핑
function getCategoryIcon(categoryId: string): React.ComponentType<{ className?: string; strokeWidth?: number }> {
  const iconMap: Record<string, React.ComponentType<{ className?: string; strokeWidth?: number }>> = {
    keyboard: Piano,
    strings: Guitar,
    winds: Music,
    percussion: Drum,
    korean: Music2,
    electronic: Cpu,
    audio: Headphones,
    accessories: Package,
  };

  return iconMap[categoryId] || Music;
}
